"use client";

import Image from "next/image";
import {
  IconBrandInstagram,
  IconBrandLinkedinFilled,
  IconBrandGithubFilled,
  IconMail,
  IconMapPin,
  IconRosetteDiscountCheckFilled,
} from "@tabler/icons-react";
import { contact } from "@/constants/site";

type ProfileCardProps = {
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
};

const socials = [
  { label: "GitHub", href: contact.github, icon: IconBrandGithubFilled },
  { label: "LinkedIn", href: contact.linkedin, icon: IconBrandLinkedinFilled },
  { label: "Instagram", href: contact.instagram, icon: IconBrandInstagram },
  { label: "Email", href: `mailto:${contact.email}`, icon: IconMail },
];

export default function ProfileCard({
  imageSrc = "/subhan-nadeem.png",
  imageAlt = "Subhan Nadeem — Senior Full-Stack Engineer and Automation Developer",
  className = "",
}: ProfileCardProps) {
  return (
    <div
      className={`flex h-full flex-col rounded-[20px] border border-white/[0.06] bg-black p-5 text-white lg:max-w-[400px] ${className}`}
    >
      <div className="relative h-[360px] overflow-hidden rounded-[14px] sm:h-[460px] md:h-[520px] lg:h-auto lg:min-h-[360px] lg:flex-1">
        <Image
          src={imageSrc}
          alt={imageAlt}
          fill
          sizes="(min-width: 1024px) 400px, 100vw"
          priority
          className="object-cover object-top"
        />
        <div className="absolute left-3 top-3 flex items-center gap-2 rounded-full border border-white/10 bg-black/60 px-3 py-1.5 text-[12px] font-semibold backdrop-blur">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
          </span>
          Open to work
        </div>
      </div>

      <div className="mt-5 flex items-center gap-1.5">
        <h2 className="text-[28px] font-bold leading-none">Subhan Nadeem</h2>
        <IconRosetteDiscountCheckFilled size={22} className="text-[#48AEEF]" />
      </div>

      <p className="mt-2 text-[16px] font-semibold text-white/90">
        Senior Full-Stack Engineer
      </p>
      <p className="mt-1 text-[15px] text-[#868E96]">
        Automation · Configurators · AI Agents
      </p>

      <p className="mt-3 flex items-center gap-1.5 text-[14px] text-[#868E96]">
        <IconMapPin size={16} />
        Pakistan · Working with clients worldwide
      </p>

      <div className="mt-5 grid grid-cols-4 gap-2">
        {socials.map(({ label, href, icon: Icon }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            className="flex h-10 items-center justify-center rounded-[10px] bg-[#0E1018] text-gray-400 transition-colors hover:bg-[#161a26] hover:text-white"
          >
            <Icon size={20} />
          </a>
        ))}
      </div>
    </div>
  );
}
